import React from "react";

import "./NikeScan.scss";
import { Scanner } from "SharedComponents";
import { ALGORITHMS } from "Constants";
import { PRODUCTS_NIKE } from "Constants";
import { withRouter } from "react-router";

class DottiScan extends React.Component {
  constructor(props) {
    super(props);
    const algorithmKey = this.props.match.params.algorithm;
    this.state = {
      algorithm: ALGORITHMS.find((algo) => algo.key === algorithmKey)
        .projectName,
    };
  }

  componentDidMount() {
    document.title = "Arylla Scanner";
  }

  render() {
    const { algorithm } = this.state;
    return (
      <div className="embedded-scan-page nike">
        <Scanner
          algorithm={algorithm}
          products={PRODUCTS_NIKE}
          url={this.props.match.url}
          customText={{}}
        />
      </div>
    );
  }
}

export default withRouter(DottiScan);
